import { PermissionsApplicationModel as Model } from './Model'


export const MODULE_NAME = 'permissions.applications'

export const PERMISSIONS_APPLICATIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PERMISSIONS_APPLICATIONS_ROUTES.LAYOUT,
  route: { name: PERMISSIONS_APPLICATIONS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-briefcase-outline',
} as const
